import { IVL_INVENTORY_EXPORT_LIMIT } from './ivlConstants'

export const IVL_QUERY_ERROR_MESSAGE = '재고를 불러오지 못했어요. 잠시 후 다시 조회해 주세요.'
export const IVL_CONTRACT_ERROR_MESSAGE = '재고를 불러오지 못했어요. 화면을 새로고침한 뒤 다시 조회해 주세요.'
export const IVL_EXPORT_ERROR_MESSAGE = '엑셀을 다운로드하지 못했어요. 다시 시도해 주세요.'
const EXPORT_LIMIT_MESSAGE = `조회 대상이 ${IVL_INVENTORY_EXPORT_LIMIT.toLocaleString()}건 이상이에요. 조회 조건을 좁혀 주세요.`

/** FE에서 선택한 사용자 안내만 원문을 보존한다. 서버·통신 예외는 이 타입으로 직접 취급하지 않는다. */
export class IvlInventoryUserError extends Error {}

const ERROR_MESSAGES = new Map([
  ['ERROR_INVALID_PARAM', '조회 조건을 확인한 뒤 다시 시도해 주세요.'],
  ['INVENTORY_QUERY_TIMEOUT', '재고 조회 시간이 오래 걸리고 있어요. 조회 조건을 좁히거나 잠시 후 다시 시도해 주세요.'],
  ['INVENTORY_UPSTREAM_CONTRACT_ERROR', IVL_CONTRACT_ERROR_MESSAGE],
  ['INVENTORY_QUANTITY_OVERFLOW', '재고 수량을 확인하지 못했어요. 관리자에게 문의해 주세요.'],
  ['SHIPPER_SCOPE_UNAVAILABLE', '화주 권한을 확인하지 못했어요. 잠시 후 다시 시도해 주세요.'],
  ['INVENTORY_EXPORT_INCOMPLETE', '일부 재고를 확인하지 못해 엑셀을 다운로드할 수 없어요. 조회 조건을 좁히거나 다시 조회해 주세요.'],
  ['INVENTORY_EXPORT_SUPPLEMENT_INCOMPLETE', '일부 상품정보 또는 단가를 확인하지 못해 엑셀을 다운로드할 수 없어요.'],
  ['INVENTORY_EXPORT_SUPPLEMENT_FAILED', '일부 상품정보 또는 단가를 확인하지 못해 엑셀을 다운로드할 수 없어요.'],
  ['INVENTORY_EXPORT_SUPPLEMENT_TIMEOUT', '상품정보 또는 단가 조회 시간이 오래 걸리고 있어요. 잠시 후 다시 다운로드해 주세요.'],
  ['INVENTORY_EXPORT_LIMIT_EXCEEDED', EXPORT_LIMIT_MESSAGE],
  ['INVENTORY_EXPORT_BUSY', '다른 재고 엑셀을 처리하고 있어요. 잠시 후 다시 시도해 주세요.'],
  ['INVENTORY_EXPORT_FILE_FAILED', IVL_EXPORT_ERROR_MESSAGE],
])

/** 서버 message와 일반 Error.message는 사용자에게 직접 노출하지 않는다. */
export const ivlInventoryErrorMessage = (error: unknown, fallback = IVL_QUERY_ERROR_MESSAGE): string => {
  if (error instanceof IvlInventoryUserError) return error.message
  const response = (error as { response?: { status?: number; data?: { meta?: { errorCode?: unknown; message?: unknown } } } })?.response
  const code = response?.data?.meta?.errorCode
  // 현재 BE는 엑셀 상한을 공용 입력 오류 코드로 반환한다. 확인된 고정 문구만 인식하고 원문은 출력하지 않는다.
  if (code === 'ERROR_INVALID_PARAM' && response?.data?.meta?.message ===
    '정상 데이터가 30,000행 이상이면 엑셀을 다운로드할 수 없어요. 조회 조건을 좁혀 주세요.') return EXPORT_LIMIT_MESSAGE
  const message = typeof code === 'string' ? ERROR_MESSAGES.get(code) : undefined
  if (message) return message
  if (response?.status === 401) return '로그인 상태를 확인한 뒤 다시 시도해 주세요.'
  if (response?.status === 403) return '재고 조회 권한이 없어요. 관리자에게 문의해 주세요.'
  if (response?.status === 400) return '조회 조건을 확인한 뒤 다시 시도해 주세요.'
  return fallback
}
